<template>
	<div class="row text-editor-block">
		<template v-if="hide_toggle">
			<textarea style="width: 100%;" v-show="loaded" :id="id" v-model="model"></textarea>
		</template>
		<template v-else>
			<div class="col-lg-11 col-md-11 col-sm-11 col-xs-11">
				<textarea style="width: 100%;" :id="id" v-model="model[field_key]"></textarea>
			</div>
			<div class="col-lg-1 col-md-1 col-sm-1 col-xs-1" v-if="!loaded">
				<a href="javascript:;" @click="init()">
					<i class="material-icons">&#xE23C;</i>
				</a>
			</div>
		</template>
	</div>
</template>
<script>
	export default {
		props: {pid: String, field_key: String, model: Object, hide_toggle: Boolean, init_value: String},
		data() {
			return {loaded: false, id: this.pid}
		},
		created() {
			// Set a custom init value.
			Vue.set(this.model, this.field_key, this.init_value);

			// Remove invalid values from id '.','. to avoid Jquery selector's errors.
			if (this.id) {
				this.id = this.getParsedId(this.id);
			} else {
				this.id = 'wys-' + Date.now() + '-' + parseInt((Math.random() * 100), 10);
			}

			if (this.hide_toggle) {
				let wait = !window.jQuery || !$('#' + this.id).length;
				if (wait) {
					setTimeout(() => this.init(), 2000);
				} else {
					this.init();
				}
			}
		},
		methods: {
			init() {
				let textarea = $('#' + this.id);
				this.loaded = true;
				textarea.trumbowyg({btns: [['bold', 'italic', 'underline'], ['link'], ['viewHTML', 'fullscreen']], autogrow: true, autogrowOnEnter: true});
				textarea.trumbowyg().on('tbwchange', () => {
					this.model[this.field_key] = textarea.trumbowyg('html')
				});
			},
			getParsedId(id) {
				return id.replace(/\.|\//g, '-');
			}
		}
	}
</script>
